// Simple content for demo
module.exports = {
  label: 'Select a country',
  options: [
    {
      value: '1',
      label: 'Belgium',
    },
    {
      value: '2',
      label: 'France',
    },
    {
      value: '3',
      label: 'Luxembourg',
    },
    {
      value: '4',
      label: 'Germany',
    },
    {
      value: '5',
      label: 'Bulgaria',
    },
  ],
  width: 'm',
};
